import { render, staticRenderFns } from "./AdminVouchers.vue?vue&type=template&id=16cf63f0&scoped=true"
import script from "./AdminVouchers.vue?vue&type=script&lang=js"
export * from "./AdminVouchers.vue?vue&type=script&lang=js"
import style0 from "./AdminVouchers.vue?vue&type=style&index=0&id=16cf63f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf63f0",
  null
  
)

export default component.exports